module.exports = __webpack_public_path__ + "static/img/logo@2x.0c0292e2.png";